import state from "@/store/payment/state";
import getters from "@/store/payment/getters";
import mutations from "@/store/payment/mutations";
import * as actions from "@/store/payment/actions";

const paymentModule = {
	namespaced: true,
	getters,
	mutations,
	actions,
	state,
};

export default paymentModule;
